module.exports = __webpack_public_path__ + "d972fc731a14cd7cfeff3b4f3eb77645.pdf";